export class MyAddress {
    ID: number;
    Country: string;
    City: string;
    State: string;
    County: string;
    HouseNumber: string;
    PostalCode: string;
    StreetAddress: string;
    StreetName: string;
    FormattedAddress: string;
    PlaceId: string;
    Lat: number;
    Lng: number;
}

export default MyAddress;